import { render, staticRenderFns } from "./AutomaticInvestmentConsentV2.vue?vue&type=template&id=e9f77df2&"
import script from "./AutomaticInvestmentConsentV2.vue?vue&type=script&lang=js&"
export * from "./AutomaticInvestmentConsentV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports